import ReportedContentDetailsModal from './ReportedContentDetailsModal';

export default ReportedContentDetailsModal;
